/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Box, Divider, Flex, Radio, RadioGroup } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { FormLabel } from 'src/components/Common/FormComponent';
import {
  useGmailInboundTargetUserGroups,
  useGmailInlineTargetDomains,
} from '@Policy/hooks';
import { TargetType } from 'src/utils/enums';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { GeneralPolicyInfo, GeneralStatus } from '@Policy/Filters/General';
import { TargetUserGroups } from '@Policy/Components/TargetUserGroups';

export const TargetUserGroupsGmailInline = () => {
  const props = useGmailInboundTargetUserGroups();
  return <TargetUserGroups {...props} />;
};
export const TargetDomainGmailInline = () => {
  const props = useGmailInlineTargetDomains();
  return <TargetUserGroups {...props} />;
};

export const TargetGmailInline = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const policyTarget = policySelector((s) => s.policyTarget);
  const setTempVars = contextSelector((s) => s.setTempVars);
  const { targetType } = contextSelector((s) => s.tempVars);
  useEffect(() => {
    if (policyTarget.targetType === TargetType.UserAndGroup) {
      setTempVars({
        targetType: TargetType.UserAndGroup,
        targetUserGroups: { ...policyTarget },
      });
    } else if (policyTarget.targetType === TargetType.Domain) {
      setTempVars({
        targetType: TargetType.Domain,
        targetDomains: { ...policyTarget },
      });
    }
  }, []);
  return (
    <RadioGroup
      value={targetType}
      onChange={(value: string) => setTempVars({ targetType: value })}
    >
      <Flex mt="23px" alignItems="flex-start" direction="column">
        <Radio
          value={TargetType.Domain}
          checked={targetType === TargetType.Domain}
        >
          <FormLabel label={t('policy.label.policyTargetDomain')} width={300} />
        </Radio>
        {targetType === TargetType.Domain ? (
          <Flex mt="8px" alignItems="flex-start">
            <TargetDomainGmailInline />
          </Flex>
        ) : null}
      </Flex>
      <Flex mt="8px" alignItems="flex-start" direction="column">
        <Radio
          value={TargetType.UserAndGroup}
          checked={targetType === TargetType.UserAndGroup}
        >
          <FormLabel
            label={t('policy.label.policyTargetUserGroup')}
            width={300}
          />
        </Radio>
        {targetType === TargetType.UserAndGroup ? (
          <Flex mt="8px" alignItems="flex-start">
            <TargetUserGroupsGmailInline />
          </Flex>
        ) : null}
      </Flex>
    </RadioGroup>
  );
};
const General = () => {
  return (
    <Box>
      <GeneralStatus
        skipScanJunkEmailFolderShow={false}
        mipEnableFeatureShow={false}
      />
      <Divider mt="22px" mb="22px" />
      <GeneralPolicyInfo />
      <TargetGmailInline />
    </Box>
  );
};
export default React.memo(General);
